import { proxyFetch } from '@ps/functions/utils/proxyFetch';

import { revalidatePostStats } from '../../post-view/functions/postStatsApi';

/**
 * Create a comment on a post; resolves to the new comment's id. Goes through the
 * `/api/bio/posts/comments` proxy so the generated `PostsApi` client stays off
 * the visitor bundle.
 */
export async function createComment(
  sellerId: string,
  postId: string,
  text: string,
): Promise<string> {
  const result = await proxyFetch<{ id: string }>('/api/bio/posts/comments', {
    method: 'POST',
    body: { creatorId: sellerId, postId, text },
  });
  // The comment count changed — bust the post's cached stats so the footer's
  // count refreshes on the next view (best-effort; not part of the create).
  void revalidatePostStats(postId);
  return result.id;
}
